import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AsyncSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppPaths } from '../interfaces/app-paths';
import { AppConfig } from '../interfaces/app-config';

@Injectable({
  providedIn: 'root',
})
export class AppConfigLoaderService<T extends AppConfig> {
  private appConfig: AsyncSubject<T> = new AsyncSubject<T>();

  constructor(private http: HttpClient) { }

  loadAppConfig(config: AppPaths): Promise<T> {
    const { appConfigPath } = config.getAppPaths();

    this.appConfig.subscribe({
      next: _ => _,
      error: err => console.error('Failed to load app-config', err),
    });

    return this.http.get<T>(appConfigPath).pipe(tap(appConfig => {
      this.appConfig.next(appConfig);
      this.appConfig.complete();
      return appConfig;
    })).toPromise();
  }

  getConfig$(): Observable<T> {
    return this.appConfig.asObservable();
  }
}
